/**
 * Created by tofael on 7/13/17.
 */
import React from 'react';
import Dialog from 'material-ui/Dialog';

const ImageViewer = ({onClose, imageUrl, open}) => {
  return (
    <div>
      <Dialog
        open={open}
        onRequestClose={onClose}
      >
        <img src={imageUrl} alt="prescription" style={{width: '100%'}}/>

      </Dialog>
    </div>
  );
}
export default ImageViewer;


// WEBPACK FOOTER //
// ./src/screens/shared/image-viewer.js